module.exports = __webpack_public_path__ + "static/img/Phillip-Sami.775bbde.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Phillip-Sami.jpg
// module id = SqsE
// module chunks = 0